import { Component, Input, TemplateRef, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LocalService, Status } from 'src/service/local.service';
import { PaymentManagementService } from 'src/service/payment-management.service';

@Component({
  selector: 'app-payment-link',
  templateUrl: './payment-link.component.html',
  styleUrls: ['./payment-link.component.scss']
})
export class PaymentLinkComponent {
  @Input() isOpenPopup: boolean = false;
  @Output() onClose = new EventEmitter();
  @Output() isOpenPopupChange = new EventEmitter();
  @ViewChild('content')
  content!: TemplateRef<any>;
  @ViewChild('form') form: ElementRef;

  @Input() encRequest: string;
  @Input() accessCode: string;
  @Input() action: string;
  @Input() orderIdWithCountryCode: string;
  isChildWindow: boolean | null = null;
  windowRef = null;
  interval;

  constructor(public localService: LocalService, private offcanvasService: NgbOffcanvas, private paymentManagementService: PaymentManagementService) { }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });

      this.isChildWindow = false;
      setTimeout(() => {
        if (this.encRequest) {
          this.form.nativeElement.submit();         
        } else {
          let height = screen.availHeight;
          let width = screen.availWidth;
          this.isChildWindow = true;
          this.windowRef = window.open(this.action, "child", "toolbar=0,location=0,directories=0,status=0,menubar=0,titlebar=0,width=" + width + "px,height=" + height + "px");
        }
        this.startTimer();
      }, 200);
    }
  }

  onCloseTrigger(status?: Status) {
    if (this.windowRef) {
      this.windowRef.close();
    }
    this.onClose.emit(status);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onBeforeDismiss(): boolean {
    clearInterval(this.interval);
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  startTimer() {
    this.interval = setInterval(() => {
      this.onCheckStatus();
    }, 2000);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  onCheckStatus() {
    if (this.orderIdWithCountryCode) {
      this.paymentManagementService.getPaymentGatewayOrderStatus(this.orderIdWithCountryCode).subscribe(result => {
        if (![Status.New].includes(result.status)) {
          this.onCloseTrigger(result.status);
        } else if (this.windowRef && this.windowRef.closed) {
          this.onCloseTrigger();
        }
      });
    }
  }
}
